module.exports = __webpack_public_path__ + "assets/images/82cb5c37f63fcf1c66e2b5530cf00bd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/headshot-retouched-min.png
// module id = 390
// module chunks = 0